export function isMobile() {
  return window.innerWidth <= 768
}

export function newIsMobile() {
  return window.innerWidth <= 1024
}
